import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'

export const Footer = () => {
    return (
        <div>
            < div className = 'bg-info text-light text-center fluid mt-5'>
                <Row>
                    <Col >&copy; copyright|| All Right Reserved</Col>
                </Row>
            </div>
        </div>
    )
}
